/**
 * Utility to check if the code is running in a browser environment.
 * @returns {boolean} - Returns true if running in the browser, false if running in a server (Node.js) environment.
 */
const isBrowser = (): boolean => {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined'
}

export default isBrowser
